export enum CustomerValidationStatusTypeEnum {
  PENDING = 'pending',
  FAILED = 'failed',
  SUCCESS = 'success',
}
